<template>
  <div class="hello">
    <div class="text-titel">信息录入</div>
    <div>
      <div class="box-one" style="margin-bottom: 20px">
        <div>用户昵称:</div>
        <el-input
          v-model="recordsdata.username"
          placeholder="请输入内容"
          style="width: 60%"
        ></el-input>
      </div>
      <div class="box-one" style="margin-bottom: 20px">
        <div>级&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</div>
        <el-input
          v-model="recordsdata.level"
          placeholder="请输入内容"
          style="width: 60%"
        ></el-input>
      </div>
      <div class="box-one" style="margin-bottom: 20px">
        <div>性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</div>
        <el-select
          v-model="recordsdata.group"
          placeholder="请选择"
          style="width: 60%"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="box-one" style="margin-bottom: 20px">
        <div>积&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分:</div>
        <el-input
          v-model="recordsdata.points"
          placeholder="请输入内容"
          style="width: 60%"
        ></el-input>
      </div>
      <div class="box-one" style="margin-bottom: 20px">
        <div>备注名称:</div>
        <el-input
          v-model="recordsdata.comment"
          placeholder="请输入内容"
          style="width: 60%"
        ></el-input>
      </div>
      <div class="box-one" style="margin-bottom: 20px">
        <div>备注信息:</div>
        <el-input
          v-model="recordsdata.remark"
          placeholder="请输入内容"
          style="width: 60%"
        ></el-input>
      </div>
    </div>
    <div class="box-button">
      <el-button type="primary" round @click="themebutton">提交</el-button>
    </div>
  </div>
</template>
<script>
import { MessageBox } from "mint-ui";
export default {
  name: "bindDetail",
  data() {
    return {
      partnerinput: "",
      userinput: "",
      recordsdata: {
        id:'',
        projId: "",
        username: "",
        level: "",
        devSysName: "",
        integral: "",
        comment: "",
        remark: "",
        group:"",
      },
      options: [
        {
          value: "1",
          label: "女",
        },
        {
          value: "2",
          label: "男",
        },
      ],
      value: "",
      isShow: false,
      request: {
        phone: "",
        openId: "",
      },
      user: {},
    };
  },
  mounted() {
    this.request.openId = this.$route.query.openId;
    if (this.request.openId) {
      this.getUserInfo();
    }
  },
  methods: {
    // 提交
    themebutton(query) {
      var _t = this;
      this.common.dofeathera(
        this.common.login,
        _t.recordsdata,
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            MessageBox.alert(res.msg, "成功");
          } else if (res.code == 201) {
            MessageBox.alert(res.msg, "失败");
          } else {
            MessageBox.alert(res.msg, "失败");
          }
        },
        "weixin"
      );

      // _t.$router.push({
      //         path: "/featherusersuccess",
      //         query: query,
      //       });


    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.bindIsOk,
        { openId: this.request.openId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user = res.data;
            _t.request.phone = res.data.userphone;
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId,
            };
            _t.$router.push({
              path: "/bindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
      this.isShow = true;
    },
    unbindWeChat() {
      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then((action) => {
          _t.common.doActionGet(
            _t.common.removeBindLny,
            _t.request,
            function (res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId,
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query,
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
  margin-top: -40px;
}
.title1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 20px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 75px;
  text-align: left;
}
.tip {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 14px;
}
.btn-code {
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
}
.btn-gray {
  width: 100%;
  height: 40px;
  margin-top: 100px;
}
.wechat-user-logo {
  margin-top: 80px;
}
.box-one {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.text-titel {
  width: 100%;
  padding: 20px 0px;
  font-size: 30px;
}
.box-button {
  margin-top: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/featheradd/featheruser.vue